import { useReportContext } from "../../../../context/report_context";
import ReportOverview from "../ReportOverview";

const BusinessReportOverview = () => {

      const { storeOverview, isFetching } = useReportContext();

      const overview = [
            { amount: storeOverview?.profit || 0, title: 'Total Profit', color: '#E2B581', isNumber: true },
            { amount: storeOverview?.revenue || 0, title: 'Revenue', color: '#448DF2', isNumber: true },
            { amount: 0, title: 'Sales', color: '#845EBC', isNumber: true },
            { amount: storeOverview?.expenses || 0, title: 'Expenses', color: '#FF0000CC', isNumber: true },
            { amount: storeOverview?.qty || 0, title: 'Total Quantity', color: '#441123CC', isNumber: false },
            { amount: storeOverview?.net_profit || 0, title: 'Net Profit', color: '#667085', isNumber: true },
            { amount: storeOverview?.net_sales || 0, title: 'Net Sales', color: '#667085', isNumber: true },
            { amount: 0, title: 'Total Debt', color: '#667085', isNumber: true },
            { amount: 0, title: 'Total Credit', color: '#667085', isNumber: true },
      ];


      return (
            <div>

                  <ReportOverview
                        overview={overview}
                        loading={isFetching}
                  />
            </div>
      );
};

export default BusinessReportOverview;